import { Pipe, PipeTransform } from '@angular/core';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';
import { DatumOutputType, TabulationClassification, TabulationDatum } from '@rds/rds-base-ts';
import { RdsCodeDisplayType } from '@rds/shared-api';

import { getDatumValue } from './models/datum-util';

@Pipe({
  name: 'rdsGetDatumValue',
})
export class RdsGetDatumValuePipe implements PipeTransform {
  /**
   * Returns a value for a given Datum.
   * The map should contain each display type & their associated property names, .i.e.
   * { 'NAME': ['name'], 'VALUE': ['codeValue'], 'BOTH': ['codeValue', 'name'] }
   * @example
   * {{ codeDisplay | rdsGetDatumValue : row.cells[i].datum : map }}
   * @param displayType RdsCodeDisplayType for which datum value type to show, if value is a Code
   * @param datum Datum containing the value to retrieve
   * @param map map of property names arrays inside a value object, should be indexed using codeDisplay
   */
  transform(
    displayType: RdsCodeDisplayType,
    datum: TabulationDatum,
    variables: Array<Variable | VariableSummary | null>,
    classifications: { [id: string]: TabulationClassification },
    map: { [id: string]: string[] }
  ): DatumOutputType | null {
    if (!!map[displayType] && !!map[displayType].length) {
      return getDatumValue(datum, variables, classifications, ...map[displayType]);
    }
    return getDatumValue(datum, variables, classifications);
  }
}
